export default __webpack_public_path__ + "static/media/6a7f025f89744fc44f45e6c82542be0d1579016024513.36cfbcf5.webp";